// Ajuste: referenciamos tipos comunes alineados al OpenAPI.
// Se eliminó JsonRpcErrorDetail porque no se usa.
import type {
  ApiErrorResponse,
  RequestPayload,
  TransformedError,
} from '@/dto/common/apiErrorResponse';
import type { SerializedError } from '@reduxjs/toolkit';
import type { FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query';
// import { SerializedError } from '@reduxjs/toolkit';

export const handlerErrorResponse = <TArg = void>(endpointName: string) => {
  // Cambio: función de transformación de errores genérica para servicios Reparoly.
  // Alineada con ApiErrorResponse del OpenAPI (success, message, errors).
  return (
    error: FetchBaseQueryError | SerializedError,
    meta: FetchBaseQueryMeta | undefined,
    args: TArg,
  ): TransformedError => {
    let errorMessage: string = 'Ocurrió un error inesperado.';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let errorCode: any;
    let errorType: string | undefined;
    let originalErrorDetail: object | undefined;
    // Puede contener lista de strings por campo, string simple, etc.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let errorDetails: any;
    // let requestMethod: string | undefined;

    // Puedes usar endpointName que fue capturado por el closure
    const currentEndpointName: string = endpointName;

    // if (args && args.method) {
    //   requestMethod = args.method;
    //   const lastDotIndex = requestMethod.lastIndexOf('.');
    //   if (lastDotIndex !== -1) {
    //     requestMethod = requestMethod.substring(lastDotIndex + 1);
    //   }
    // }

    // Supresión centralizada: si la base query marcó el error como omitible, no mostrar mensaje
    try {
      const skippedByGuard: boolean = Boolean((error as any)?.meta?.skippedByTokenGuard);
      if (skippedByGuard) {
        return {
          message: '',
          code: (error as any)?.status ?? null,
          type: 'suppressed',
          details: undefined,
          originalError: error as any,
          endpointName,
        };
      }
    } catch {}

    if ('status' in error) {
      if (typeof error.status === 'number') {
        // Suprime los 401 para que el manejo centralizado (baseQuery) muestre un único modal UX
        if (error.status === 401) {
          return {
            message: '',
            code: 401,
            type: 'unauthorized',
            details: undefined,
            originalError: error as any,
            endpointName,
          };
        }
        const apiResponseError = error.data as ApiErrorResponse;

        if (apiResponseError) {
          if (apiResponseError.message !== '' && !apiResponseError.success) {
            errorMessage = apiResponseError.message;
            originalErrorDetail = apiResponseError;
            errorCode = error.status;
            errorType = 'api';
            // Si backend mando errores de validacion, los adjuntamos en details
            if (apiResponseError.errors) {
              errorDetails = apiResponseError.errors;
            }
          }
        } else {
          errorMessage = (error.data as any)?.message || `Error HTTP ${error.status}`;
          // Suprimir mensaje “Missing access token” si llegó hasta aquí
          if (String((error.data as any)?.message || '').toLowerCase().includes('missing access token')) {
            errorMessage = '';
          }
        }
      } else {
        if ('error' in error) {
          errorMessage = error.error;
        }
        if ('status' in error) {
          errorMessage = `Error desconocido con estado: ${error.status}`;
        } else {
          errorMessage = `Error desconocido. Descripción: ${JSON.stringify(error)}`;
        }
      }
    } else {
      errorMessage = error.message || errorMessage;
      if ('code' in error) {
        errorCode = error.code;
      }
    }

    return {
      message: errorMessage,
      code: errorCode,
      type: errorType,
      details: errorDetails,
      originalError: originalErrorDetail,
      // endpointName: requestMethod,
      endpointName: currentEndpointName,
    };
  };
};

// Eliminado: Manejador específico para biométrico y sus mensajes
// (no aplica a los servicios definidos en openapi.yaml de Reparoly).

export const handleUnwrapRTKError = (err: unknown): TransformedError => {
  if (err && typeof err === 'object' && 'error' in (err as any)) {
    return (err as any).error as TransformedError;
  }
  return err as TransformedError;
};
